import { createSlice } from "@reduxjs/toolkit";
import { handleLogin, logoutUser } from "./actions";
import { clear, get } from "../../../services/cookies";

import { toast } from "react-toastify";

const initToken = () => get("token") || null;
const initialState = {
  loading: false,
  success: null,
  error: null,
  loginDetails: {
    loading: false,
    details: null,
    error: null,
  },

  userDetails: {
    details: null,
  },
  isAuth: !!initToken(),
};

const loginSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    userDetails(state, action) {
      state.userDetails.details = action.payload;
    },
    logOut(state) {
      state.isAuth = false;
      clear();
      toast.success("Logout successfully");
    },
  },
  extraReducers: (builder) => {
    builder.addCase(handleLogin.pending, (state) => {
      state.loginDetails.loading = true;
      state.isAuth = false;
    });
    builder.addCase(handleLogin.fulfilled, (state, action) => {
      state.loginDetails.loading = false;
      const data = action.payload;

      state.userDetails.details = {
        first_name: data?.first_name || "",
        last_name: data?.last_name || "",
      };

      state.isAuth = !!data?.token;
    });
    builder.addCase(handleLogin.rejected, (state) => {
      state.loginDetails.loading = false;
      state.isAuth = false;
    });

    builder.addCase(logoutUser.pending, (state) => {
      // state.loading = true;
    });
    builder.addCase(logoutUser.fulfilled, (state) => {
      // state.loading = false;
      state.isAuth = false;
      state.userDetails.details = null;
      clear();
      toast.success("Logout Successfully");
    });
    builder.addCase(logoutUser.rejected, (state) => {
      // state.loading = false;
    });
  },
});

export const { userDetails, logOut } = loginSlice.actions;

export default loginSlice.reducer;
